export const ActivityType: Record<
  string,
  'passing' | 'grading' | 'viewing' | 'creating'
> = {
  PASSING: 'passing',
  GRADING: 'grading',
  VIEWING: 'viewing',
  CREATING: 'creating',
};
